import { render, staticRenderFns } from "./SelectProductUpsell.vue?vue&type=template&id=c8acc47a&scoped=true"
import script from "./SelectProductUpsell.vue?vue&type=script&lang=js"
export * from "./SelectProductUpsell.vue?vue&type=script&lang=js"
import style0 from "./SelectProductUpsell.vue?vue&type=style&index=0&id=c8acc47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8acc47a",
  null
  
)

export default component.exports